import { useKeycloak } from "@react-keycloak/web";
import { Avatar, Dropdown } from "antd";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../app/store";
import PLACEHOLDER_IMG from "../../../assets/images/avatar.svg";
import { userLoggedOut } from "../../../features/auth/authSlice";

export default function ProfileMenu() {
  const dispatch = useAppDispatch();
  const { keycloak } = useKeycloak();
  const { role, user } = useAppSelector((state) => state.auth);

  const navigateUrl =
    role === "admin" ? "/admin/dashboard" : "/organization/dashboard";

  const handleLogout = () => {
    dispatch(userLoggedOut());
    keycloak.logout();
    localStorage.clear();
  };

  return (
    <Dropdown
      placement="bottomRight"
      arrow={{ pointAtCenter: true }}
      className="cursor-pointer"
      rootClassName="!left-auto !right-5"
      dropdownRender={() => (
        <ul className="list-none bg-white shadow p-1 rounded">
          <li>
            <Link
              to={navigateUrl}
              className="py-1.5 px-8 cursor-pointer select-none text-body hover:text-primary hover:bg-[#FFF5F4] text-sm rounded block"
            >
              My Profile
            </Link>
          </li>
          <li
            onClick={handleLogout}
            className="py-1.5 px-8 cursor-pointer select-none text-body hover:text-primary hover:bg-[#FFF5F4] text-sm rounded"
          >
            Logout
          </li>
        </ul>
      )}
    >
      <div className="flex items-center gap-2.5 cursor-pointer">
        <Avatar
          size={44}
          src={
            (user?.profile as unknown as { pro_pic: string })?.pro_pic ||
            PLACEHOLDER_IMG
          }
        />
      </div>
    </Dropdown>
  );
}
